import { Http } from '@/services/http'
import { ParamsClean } from '@/common/decorators/params-clean'
import { Injectable } from '@tanbo/vue-di-plugin'

export interface DetailQueryParams {
  task_id?: string
  limit?: number
  page?: number
  status?: number
}

export interface Detail {
  device_id: string
  computer_name: string
  user_mark: string
  client_ip: string
  system_ip: string
  mac: string
  group_name?: string
  login_status: number
  /** 系统类型 1-windows 2-linux */
  system_type?: number
  status: string
}

@Injectable()
export class CommandStatService {
  constructor (private http: Http) {
  }

  @ParamsClean()
  async get (params: Partial<DetailQueryParams>) {
    return this.http.post<{
      total: number
      list: Detail[]
    }>('/terminal-order/task-detail', params)
  }
}
